<div class="modal-body">
    <cm-dynamic-form-content-details [contentDetails]="details"></cm-dynamic-form-content-details>
    <div class="entries-container" (click)="!disabled && screenChange.emit(PAGES.FORM_MULTIPLE_COMPLETE)">
        <span class="cm-link bold">{{ formQuantity || 0 }} entries</span>
        <div><span class="draft-label">draft</span> <i class="chevron-right"></i></div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-default" (click)="dismissModal()">CLOSE</button>
    <button class="btn btn-primary" (click)="submitForm()" [disabled]="disabled">Submit</button>
</div>
